import { mergePolygonsIfTheyIntersect } from "@nova/calculate-union"
import {
    resetFirePerimeterPreview,
    selectEditingFirePerimeterId,
    selectNextFirePerimeterName,
    selectPreviewFirePerimeterPolygons,
    selectPreviewPolygons,
    updatePerimeterCanConfirm,
} from "plugins/DrawPerimeter/FirePerimeterSlice"
import { selectFirePerimeterById } from "./selectors"
import { createPerimeter, updatePerimeter } from "features/pubsub/entityActions/cubes/perimeter"
import { selectUserID } from "user/profile/selectors"
import { createAppThunk } from "integrations/redux/hooks"
import { setActiveSidePanelModal } from "panels/content/side-panel/slice"
import { setActiveTool } from "plugins/Toolbox/tool-registry"
import { setActiveFeatureId, setActiveLayerId } from "panels/content/side-panel/slice.new"

export const submitPerimeterAuto = createAppThunk(async (_, { getState, dispatch }) => {
    const state = getState()
    const perimeterId = selectEditingFirePerimeterId()(state)
    const polygons = selectPreviewPolygons(state)
    const existingPerimeter = selectFirePerimeterById(perimeterId || "")(state)
    const nextFirePerimeterName = selectNextFirePerimeterName(state)
    const userId = selectUserID(state)!

    const mergedPolygons = (await mergePolygonsIfTheyIntersect(polygons)).map((coordinates) => ({
        coordinates,
    }))
    dispatch(
        !!existingPerimeter
            ? updatePerimeter({
                  id: existingPerimeter.id,
                  updates: {
                      polygons: mergedPolygons,
                  },
              })
            : createPerimeter({
                  data: {
                      polygons: mergedPolygons,
                      name: nextFirePerimeterName,
                      createdBy: { userId },
                  },
              })
    )
    dispatch(setActiveSidePanelModal(undefined))
    dispatch(setActiveTool(undefined))
    dispatch(resetFirePerimeterPreview())
    dispatch(setActiveFeatureId({ feature: undefined }))
    dispatch(setActiveLayerId({ id: undefined }))
    dispatch(updatePerimeterCanConfirm(false))
})

export const submitPerimeterUpload = createAppThunk(async (_, { getState, dispatch }) => {
    const state = getState()

    const perimeterId = selectEditingFirePerimeterId()(state)
    const existingPerimeter = selectFirePerimeterById(perimeterId || "")(state)
    const nextFirePerimeterName = selectNextFirePerimeterName(state)
    const userId = selectUserID(state)!
    const previewPolygons = selectPreviewFirePerimeterPolygons(state)
    const polygons = previewPolygons.map((ring) => ({
        coordinates: ring.coordinates,
    }))
    if (existingPerimeter) {
        const mergedPolygons = (
            await mergePolygonsIfTheyIntersect([
                ...polygons.map(({ coordinates }) => coordinates),
                ...existingPerimeter.polygons.map(({ coordinates }) => coordinates),
            ])
        ).map((coordinates) => ({
            coordinates,
        }))
        dispatch(
            updatePerimeter({
                id: existingPerimeter.id,
                updates: {
                    polygons: mergedPolygons,
                },
            })
        )
    } else {
        dispatch(
            createPerimeter({
                data: {
                    polygons,
                    name: nextFirePerimeterName,
                    createdBy: { userId },
                },
            })
        )
    }

    dispatch(setActiveSidePanelModal(undefined))
    dispatch(setActiveTool(undefined))
    dispatch(resetFirePerimeterPreview())
    dispatch(setActiveFeatureId({ feature: undefined }))
    dispatch(setActiveLayerId({ id: undefined }))
    dispatch(updatePerimeterCanConfirm(false))
})
